/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/no-unresolved */
/* eslint-disable react/no-unknown-property */
/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { useState, useEffect, Fragment } from 'react';
import { useNavigate } from 'react-router-dom';
import storage from '@/utils/storage';
import { Header } from '@/components/header'
import { SideMenu } from '@/components/sidemenu'
import Sidebar from "react-sidebar";
import { ApiGetUserNameInfo } from '@/features/homepage/api/ApiGetUserNameInfo';
import Login from '@/pages/Login';
import { LoadingSpinner } from '../SpinnerOverlay';
import Bg from "@/assets/img/Background.png";

type LayoutProps = {
  children: React.ReactNode;
  title?: string;
  description?: string;
};
const mql = window.matchMedia(`(min-width: 800px)`);

export const Layout: React.FC<LayoutProps> = ({
  children,
  title = 'title',
  description = 'description',
}) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [sidebarDocked, setSidebarDocked] = useState(mql.matches);

  mql.addListener(() => {
    setSidebarDocked(mql.matches);
  });
  const getToken = storage.getToken();
  const [token, setToken] = useState(getToken);
  const [navBarContent, setNavBarContent] = useState('');
  const [navLogoContent, setNavLogoContent] = useState('');
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    setToken(getToken);
    if (!getToken) {
      navigate("/login");
      return;
    }
    const fetchUserName = async () => {
      try {
        const res = await ApiGetUserNameInfo();
        storage.setVkorg(res.vkorg);
        setNavBarContent(res.name);
        setNavLogoContent(res.vkorg);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching username:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUserName();
  }, []);

  if (loading == true) {
    return <LoadingSpinner />;
  }


  return (
    <Fragment>
      {token &&
        <Sidebar
          sidebar={<SideMenu toggleMenu={() => setSidebarOpen(false)} companyCode={navLogoContent} nameUser={navBarContent} />}
          open={sidebarOpen}
          onSetOpen={setSidebarOpen}
          docked={sidebarDocked}
          transitions={false}
        >
          <Header
            toggleMenu={() => setSidebarOpen(true)}
            modeLogin={true}
            nameUser={navBarContent}
            vkorg={navLogoContent}
          />
          <div className="container-fluid padding-content background-cover">{children}</div>
        </Sidebar>
      }
      {!token && <Login></Login>
      }
    </Fragment>
  );
};
